import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';
import { BrokerItem } from '../types';
import { sendClickStat } from '@/utils/stat';

export default /*#__PURE__*/_defineComponent({
  __name: 'QsList',
  props: {
    qsList: {
        type: Array as PropType<BrokerItem[]>,
        default: () => [],
    },
    tjid: {
        type: String,
        default: '',
    },
},
  setup(__props) {

const props = __props;


// 跳转开户
const startToKaiHu = (brokerId: number) => {
    sendClickStat('gpkh_cot_scenelist_pgclick_specific', { activityId: props.tjid, qs: brokerId });
    window.jumpToKaihu({ webid: 'PagePhoneVerification', 'qsid': brokerId, 'tjid': props.tjid });
};

return { __sfc: true,props, startToKaiHu }
}

})